<!-- Navigation Bar -->
<app-nav-bar></app-nav-bar>
<!-- Navbar End -->

<div appScrollspy [spiedTags]="['SECTION']">
  <!-- Hero Start -->
  <section class="hero-1-bg position-relative"
    style="background-image: url('../../../assets/images/tech-mesh.svg');background-size: cover;background-repeat: no-repeat;background-position: center;background-color:#000f66;">
    <div class="container">
      <div class="align-items-center active">
        <div class="w-75 mx-auto">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-12">
                <div class="text-center">
                  <h1 class="text-white hero-4-title font-weight-light line-height-1_4 mb-4">OUR SERVICES</h1>
                  <p class="text-white">Bemddops is an enabler of digital transformation. Our services and
                    resources are dedicated to offering tech solutions for business re-engineering and enhancement no
                    matter the
                    industry.</p>

                    <p class="text-white">Inspired by the limitless ingenuity of Africa and backed by global expertise, our Technology Strategy & 
                      consulting practice is designed for the unique challenges and immense opportunities in Africa.</p>

                    <p class="text-white">We're not just tech consultants; consider us your co-pilots in digital transformation. 
                      Our mission is to help you craft a tailor-made technology vision that drives your corporate strategy, 
                      while ensuring that every money invested in technology creates sustainable value. 
                    </p>

                    <p class="text-white">We don’t just lead in helping businesses adopt technology, we enable businesses adopt it in a 
                      way that’s aligned with the unique dynamics of today’s African business ecosystems.
                    </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div style="width: 100%;margin-top: 6rem;">
      <svg viewBox="0 0 1440 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="718" cy="191" rx="959" ry="191" fill="white" />
      </svg>
    </div>

  </section>




  <app-service-list></app-service-list>
  <app-why-we-are-unique></app-why-we-are-unique>
  <app-main-services-accordion></app-main-services-accordion>
  <app-footer></app-footer>
